module.exports = __webpack_public_path__ + "img/statistics_dj2.5e12fd33.png";